export default __webpack_public_path__ + "static/media/investment.102f0983.jpg";